import { Suspense } from 'react';

import { Box, Skeleton, Stack, useMantineTheme } from '@mantine/core';

import { useParams } from 'react-router-dom';

import { VaultSearchResultList } from '../../features/bidResponse/components/vaultSearch/components/VaultSearchResultList';
import { VaultSearchInput } from '../../features/bidResponse/components/vaultSearch/components/VaultSearchInput';
import { VaultSearchResultsHeader } from '../../features/bidResponse/components/vaultSearch/components/VaultSearchResultHeader';
import { VaultSearchResultTitle } from '../../features/bidResponse/components/vaultSearch/components/VaultSearchResultTitle';
import { useGetVaultSearchByIdQuery } from '../../features/bidResponse/components/vaultSearch/hooks/vaultSearch.hook';
import { GradientBorder } from '../../shared/components/GradientBorder';

export function VaultSearchResultsPage() {
  return (
    <Suspense fallback={<VaultSearchResultsSkeleton />}>
      <SafeVaultSearchResultsPage />
    </Suspense>
  );
}

function SafeVaultSearchResultsPage() {
  const { id } = useParams();
  const searchId = Number(id);
  const { data } = useGetVaultSearchByIdQuery(searchId);
  const theme = useMantineTheme();
  return (
    <>
      <VaultSearchResultTitle searchData={data} />
      <Stack
        h="100%"
        w="100%"
        spacing="02"
        mt="01"
        sx={{
          overflowY: 'auto',
        }}
      >
        <GradientBorder
          borderWidth={1.6}
          borderRadius={12}
          gradient={theme.other.gradients.background2}
          wrapperProps={{
            w: '100%',
            h: 'auto',
          }}
          contentProps={{
            w: '100%',
            p: '04',
            sx: {
              overflowY: 'auto',
            },
          }}
        >
          <Stack spacing="02">
            <VaultSearchResultsHeader searchData={data} />
            <VaultSearchResultList searchData={data} />
          </Stack>
        </GradientBorder>
      </Stack>

      <GradientBorder
        borderWidth={1.6}
        borderRadius={24}
        gradient={theme.other.gradients.background2}
        wrapperProps={{
          w: '100%',
          maw: '878px',
          sx: {
            margin: 'auto',
          },
        }}
        contentProps={{
          w: '100%',
        }}
      >
        <Box
          w="100%"
          maw="878px"
          p="04"
          sx={theme => ({
            borderRadius: 20,
            background: theme.other.gradients.background2,
          })}
        >
          <VaultSearchInput />
        </Box>
      </GradientBorder>
    </>
  );
}

function VaultSearchResultsSkeleton() {
  const searchItem = (index: number) => (
    <Stack
      px="04"
      py="03"
      spacing="01"
      w="100%"
      key={index}
      sx={theme => ({
        borderRadius: '12px',
        border: `1px solid ${theme.colors.gray[1]}`,
      })}
    >
      <Skeleton h={18} w={80} radius="xl" />
      <Skeleton h={18} w={240} radius="xl" />
      <Skeleton h={18} w={150} radius="xl" />
      <Skeleton h={18} w={150} radius="xl" />
    </Stack>
  );

  return (
    <>
      <Skeleton height={15} width={'30%'} />
      <Stack h="100%" w="100%" spacing="02" mt="01">
        {Array.from({ length: 5 }).map((_, index) => searchItem(index))}
      </Stack>
      <Skeleton height={112} width={'100%'} maw="878px" m="auto" />
    </>
  );
}
